import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=d1c12754"
import script from "./auditDetail.vue?vue&type=script&lang=js"
export * from "./auditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1c12754')) {
      api.createRecord('d1c12754', component.options)
    } else {
      api.reload('d1c12754', component.options)
    }
    module.hot.accept("./auditDetail.vue?vue&type=template&id=d1c12754", function () {
      api.rerender('d1c12754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcFarmList/auditDetail.vue"
export default component.exports